import React from 'react';
import { useHistory } from 'react-router-dom';
import Layout from '../components/Layout';
import BigButton from '../components/BigButton';
import { rhymesData } from '../data/rhymes';
import { useSpeech } from '../hooks/useSpeech';
import './Words.css'; // Reuse grid styles

const Rhymes = () => {
    const history = useHistory();
    const { speak } = useSpeech();

    const handleRhymeClick = (rhyme) => {
        speak(rhyme.title);
        setTimeout(() => {
            history.push(`/rhymes/${rhyme.id}`);
        }, 500);
    };

    return (
        <Layout title="Nursery Rhymes" onBack={() => history.push('/')}>
            <div className="words-grid">
                {rhymesData.map((rhyme) => (
                    <BigButton
                        key={rhyme.id}
                        label={rhyme.title}
                        icon={rhyme.emoji}
                        color={rhyme.color}
                        onClick={() => handleRhymeClick(rhyme)}
                    />
                ))}
            </div>
        </Layout>
    );
};

export default Rhymes;
